<script setup>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { nextTick, ref, watch, onMounted } from 'vue';

const urlParams = new URLSearchParams(window.location.search);
const inquiryType = urlParams.toString().length > 0 ? urlParams.get('type') : null;
const categoryList = ref([
    {
        title: 'interested in buying a property',
        link: '#',
        subCategory: [
            {
                title: 'request a quotation',
                link: '/contact-us/quotation',
            },
            {
                title: 'schedule a visit',
                link: '/contact-us/visit',
            },
        ],
    },
    {
        title: 'just hoping to ask some questions',
        link: '/contact-us/inquiry',
        subCategory: [],
    },
]);

const selectedCategory = ref('<select an option>');
const selectedCategoryIndex = ref(0);
watch(selectedCategory, (newValue, prev) => {
    nextTick(() => {
        if (document.querySelector('#subcategory') != null) {
            document
                .querySelector('#subcategory')
                .getElementsByClassName('vs__selected')[0]
                .classList.remove('error');
        }
        selectedSubCategory.value = '<select an option>';
        redirectLink.value = newValue.link;
        selectedCategoryIndex.value = categoryList.value.findIndex(
            (x) => x.title === newValue.title
        );

        // dropdown width adjustment
        if (newValue.title === 'interested in buying a property') {
            window.document.querySelector('#category').style.width = '326px';
        }
        if (newValue.title === 'a property owner') {
            window.document.querySelector('#category').style.width = '200px';
        }
        if (newValue.title === 'just hoping to ask some questions') {
            window.document.querySelector('#category').style.width = '340px';
        }
    });
});

onMounted(() => {
    if (
        inquiryType &&
        selectedCategory.value.title === 'just hoping to ask some questions'
    ) {
        window.document.querySelector('#category').style.width = '340px';
    }
});

const selectedSubCategory = ref('<select an option>');
const selectedSubCategoryIndex = ref(0);
const redirectLink = ref('#');
watch(selectedSubCategory, (newValue, prev) => {
    document
        .querySelector('#subcategory')
        .getElementsByClassName('vs__selected')[0]
        .classList.remove('error');
    redirectLink.value = '#';
    selectedSubCategoryIndex.value =
        selectedCategory.value.subCategory.findIndex(
            (x) => x.title === newValue.title
        );
    redirectLink.value =
        categoryList.value[selectedCategoryIndex.value].subCategory[
            selectedSubCategoryIndex.value
        ].link;
});

function startButton() {
    if (redirectLink.value !== '#') {
        return location.replace(redirectLink.value)
    }
    document
        .querySelector('#subcategory')
        .getElementsByClassName('vs__selected')[0]
        .classList.remove('error');
    if (
        selectedSubCategory.value == '<select an option>' ||
        redirectLink.value == '#'
    ) {
        document
            .querySelector('#subcategory')
            .getElementsByClassName('vs__selected')[0]
            .classList.add('error');
        return;
    }
    location.replace(redirectLink.value);
}
</script>
<template>
    <section id="contact-us" class="tw-px-[18px] tw-py-[100px] md:tw-py-[22px]">
        <h1 class="tw-text-darkGreen tw-text-3xl tw-mb-16">
            Ortigas Land is here to assist you.
        </h1>
        <h3 class="tw-text-darkGreen tw-text-2xl tw-mb-8">
            What best describe your concern?
        </h3>
        <div
            class="tw-font-medium tw-mb-16 tw-text-[20px] tw-block xl:tw-flex tw-items-center"
        >
            <span class="tw-mr-1 tw-w-[40px]"> I am </span>
            <span>
                <v-select
                    id="category"
                    :options="categoryList"
                    :searchable="false"
                    v-model="selectedCategory"
                    label="title"
                ></v-select>
            </span>
            <span
                v-if="selectedCategory.title == 'interested in buying a property'"
                class="tw-block md:tw-flex tw-items-center"
            >
                <span class="tw-mr-1 tw-w-[169px]"> and I would like to </span>
                <v-select
                    id="subcategory"
                    :options="
                        categoryList[selectedCategoryIndex]['subCategory']
                    "
                    :searchable="false"
                    v-model="selectedSubCategory"
                    label="title"
                ></v-select>
            </span>
        </div>
        <button
            @click="startButton"
            id="redirect-button"
            class="tw-bg-midGreen tw-border-none tw-h-[40px] tw-w-[214px] tw-text-white tw-text-[12px] tw-tracking-[2px]"
        >
            LET'S GET STARTED >
        </button>
    </section>
</template>
<style>
.v-select {
    border: none;
    width: 326px;
    display: inline-block;
}
.vs__dropdown-toggle {
    border: none;
    height: 39px;
}
.vs__actions {
    display: none;
}
.v-select {
    margin: 0 -8px;
    margin-right: -25px;
}
.vs__selected {
    color: #a3a277;
    opacity: 1 !important;
    text-decoration: underline;
    text-underline-offset: 5px;
}
.vs--open .vs__selected {
    margin: 0;
}
.vs__dropdown-menu {
    width: 350px !important;
    border-radius: 15px;
    top: 0;
    color: #a3a277;
}
.error {
    color: red;
}
.w-322 {
    width: 322px;
}
.w-194 {
    widows: 296px;
}
.w-340 {
    width: 340px;
}
</style>
